import {Variants} from "framer-motion";

export class MotionUtils {
  public static readonly overlay: Variants = {
    init: {
      opacity: 0,
    },
    in: {
      opacity: 1,
      display: 'block'
    },
    out: {
      opacity: 0,
      transition: { duration: 0.1, ease: 'easeInOut', delay: 0.24 },
      transitionEnd: { display: 'none' }
    }
  }
  public static readonly fade: Variants = {
    init: {
      opacity: 0,
    },
    in: {
      opacity: 1,
    },
    out: {
      opacity: 0,
    }
  }

  public static readonly tooltip: Variants = {
    init: {
      opacity: 0,
      display: 'none',
      transition: { duration: 0.1, ease: 'easeInOut'},
      transitionEnd: { display: 'none' }
    },
    hover: {
      opacity: 1,
      display: 'block',
      transition: { duration: 0.2, ease: 'easeInOut'},
    },
  }
}
